import { useCallback, useState, type TouchEvent } from 'react';

interface UseSwipeConfig {
  threshold?: number;
  minSwipeDistance?: number;
}

export const useSwipe = (
  onSwipeLeft: () => void,
  onSwipeRight: () => void,
  config: UseSwipeConfig = {}
) => {
  const { threshold = 50, minSwipeDistance = 30 } = config;
  const [touchStart, setTouchStart] = useState<number | null>(null);
  const [touchEnd, setTouchEnd] = useState<number | null>(null);

  const onTouchStart = useCallback((event: TouchEvent) => {
    setTouchEnd(null);
    setTouchStart(event.targetTouches[0].clientX);
  }, []);

  const onTouchMove = useCallback((event: TouchEvent) => {
    setTouchEnd(event.targetTouches[0].clientX);
  }, []);

  const onTouchEnd = useCallback(() => {
    if (!touchStart || !touchEnd) {
      return;
    }

    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > threshold;
    const isRightSwipe = distance < -threshold;

    if (Math.abs(distance) > minSwipeDistance) {
      if (isLeftSwipe && onSwipeLeft) {
        onSwipeLeft();
      }

      if (isRightSwipe && onSwipeRight) {
        onSwipeRight();
      }
    }
  }, [
    touchStart,
    touchEnd,
    threshold,
    minSwipeDistance,
    onSwipeLeft,
    onSwipeRight,
  ]);

  return {
    onTouchStart,
    onTouchMove,
    onTouchEnd,
  };
};
